var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "title",
    class: {
      sk_style: _vm.isInSecondKill
    }
  }, [_c('h2', {
    staticClass: "txt",
    class: {
      hideTitle: _vm.hideTitle
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title)), _vm.level ? _c('span', {
    staticClass: "level"
  }, [_vm._v(_vm._s(_vm.getLevelDisplay(_vm.level)))]) : _vm._e()]), !_vm.hideMore && !_vm.isNotJump ? _c('a', {
    directives: [{
      name: "report",
      rawName: "v-report",
      value: _vm.report,
      expression: "report"
    }],
    staticClass: "more",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function click($event) {
        return _vm.toMore();
      }
    }
  }, [_vm._v("\n    更多"), _c('img', {
    staticClass: "arrow_r",
    attrs: {
      "src": "//puui.qpic.cn/vupload/0/20181020_1540030485363_jw2ogu8vvtt.png/0",
      "alt": ""
    }
  })]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };